var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TfButton',{staticClass:"cta-email-support",attrs:{"href":"mailto:support@threeflow.com","size":"text","tag":"a","target":"_blank","type":_vm.type,"no-branding":_vm.noBranding}},[_vm._t("default",function(){return [_vm._v("\n    contact support\n  ")]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }